/* @flow */
import React from 'react';
import Hit from '../Hit/Hit';
import type {Shape as HitShape} from '../Hit/Hit';

type Props = {
    hitData: HitShape,
    isDatelessSearch?: boolean
};

export default function ExpandedSearchGroupHitPlaceholder({
    hitData,
    isDatelessSearch
}: Props) {
    return (
        <div className={'ExpandedSearchGroupHitPlaceholder'}>
            <div className={'ExpandedSearchGroupPlaceholder__hit'}>
                <Hit
                    isDatelessSearch={isDatelessSearch}
                    hit={hitData}
                    isWithoutAnchor
                />
            </div>
            <div className={'ExpandedSearchGroupHitPlaceholder__overlay'} />
        </div>
    );
}
